<template>
  <footer class="footer">
    <div class="footer__body">
      <small class="footer__copyright">Copyright (C) Retty, Inc. All Rights Reserved.</small>
      <fade-in-transition>
        <global-footer-scroll-top-button
          v-show="position > 100"
          class="footer__button" />
      </fade-in-transition>
    </div>
  </footer>
</template>

<script>
import GlobalFooterScrollTopButton from '@/mikan/_shared/components/molecules/GlobalFooterScrollTopButton.vue';
import FadeInTransition from '@/mikan/_shared/components/transitions/FadeInTransition.vue';

export default {
  components: {
    FadeInTransition,
    GlobalFooterScrollTopButton,
  },
  data() {
    return {
      position: 0,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.getScrollPosition);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.getScrollPosition);
  },
  methods: {
    getScrollPosition() {
      this.position = document.documentElement.scrollTop || document.body.scrollTop;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/pc/base/constants';

$footer-button-width: 115px;

.footer {
  width: 100%;
  background-color: $color-navy-05;

  &:nth-child(n + 2) {
    margin-top: 36px;
  }

  &::after {
    display: block;
    width: 100%;
    height: 1px;
    background-image: $gradient-orange;
    content: '';
  }

  &__body {
    position: relative;
    display: flex;
    width: $full-width;
    align-items: center;
    justify-content: center;
    padding: 12px $global-gutter;
    margin: 0 auto;
  }

  &__copyright {
    color: $color-navy;
    font-size: $size-xs;
    line-height: 1;
  }

  &__button {
    position: fixed;
    bottom: 0;
    left: 50%;
    width: $footer-button-width;
    margin-left: calc((#{$full-width} / 2) - #{$footer-button-width});
  }
}
</style>
